import { methodOf, MethodTag } from "./PostmanVIewHelper";

function TreeNodeComponent({ node, selectedId, onSelect, collapsed, toggle, forceOpen }) {
  if (node.kind === "endpoint") {
    return (
      <li>
        <button
          type="button"
          className={`ad-leaf ${selectedId === node.id ? "is-active" : ""}`}
          onClick={() => onSelect(node.id)}
        >
          <MethodTag method={methodOf(node)} small />
          <span className="ad-leaf-name">{node.name}</span>
        </button>
      </li>
    );
  }
  const open = forceOpen || !collapsed.has(node.id);
  return (
    <li>
      <div className={`ad-folder-row ${selectedId === node.id ? "is-active" : ""}`}>
        <button
          type="button"
          className="ad-chevron"
          aria-label={open ? `Collapse ${node.name}` : `Expand ${node.name}`}
          aria-expanded={open}
          onClick={() => toggle(node.id)}
        >
          <svg viewBox="0 0 12 12" width="12" height="12" style={{ transform: open ? "rotate(90deg)" : "none" }}>
            <path d="M4 2l4 4-4 4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <button type="button" className="ad-folder-name" onClick={() => onSelect(node.id)}>
          {node.name}
        </button>
      </div>
      {open && (
        <ul className="ad-tree ad-nested">
          {node.item.map((c) => (
            <TreeNodeComponent
              key={c.id}
              node={c}
              selectedId={selectedId}
              onSelect={onSelect}
              collapsed={collapsed}
              toggle={toggle}
              forceOpen={forceOpen}
            />
          ))}
        </ul>
      )}
    </li>
  );
}

export default TreeNodeComponent